import React from "react";
import { Link } from "react-router-dom";
import Layout from "../../Layout";
import HeaderUser from "../HeaderUser";

const SuccessUserUpload = () => (
  <Layout>
    <HeaderUser />
    <main className="layout-container">
      <div className="container ctr">
        <div className="bi-success-check">
          <i className="bi bi-check2-circle" aria-hidden="true"></i>
          <span className="sr-only">Success</span>
        </div>
        <div className="lg-msg" role="status" aria-live="polite">
          User upload has started successfully.
        </div>
        <div className="text-size6 spacer-margin3">
          All users will be added as soon as possible, depending on the number of
          users being processed. <br />
          To check the current list, please use the button below.
        </div>
        <Link to={"/users"} className="btn btn-primary" role="button">
          Manage Users
        </Link>
      </div>
    </main>
  </Layout>
);

export default SuccessUserUpload;
